import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Plane, MapPin } from 'lucide-react';

const CharleroiAnvers = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Charleroi Anvers | Transfert Aéroport Charleroi - Antwerpen</title>
        <meta name="description" content="Transfert Charleroi Anvers. Taxi privé aéroport Charleroi - Anvers. 1h30, prix fixe. Service porte-à-porte 24/7." />
        <meta name="keywords" content="charleroi anvers, taxi charleroi anvers, transfert aeroport charleroi anvers, charleroi antwerpen" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/charleroi-anvers" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Charleroi ↔ Anvers
          </h1>
          <p className="text-xl text-gray-300 text-center mb-8">
            Transfert privé Aéroport Charleroi - Anvers. 1h30, prix fixe garanti.
          </p>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Aéroport Charleroi" defaultDropoff="Anvers" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Transfert Charleroi - Anvers</h2>
          <p className="text-gray-300">
            <strong>Transfert direct</strong> Aéroport Charleroi Brussels South → Anvers (Antwerpen). 
            Trajet de 1h30 en tout confort. Suivi de vol, prix fixe, service 24/7.
          </p>
        </div>
      </section>
    </div>
  );
};

export default CharleroiAnvers;